import Image from 'next/image';
import photo from '../../public/elnur.jpg';

const ElnurTeamMember = () => {
  return (
    <div className="flex flex-col md:flex-row items-center justify-center md:justify-between mt-16 mb-16 mx-4 md:mx-24">
      <div className="mb-10 md:mb-0">
        <Image
          src={photo}
          alt="Elnur Mammadov"
          className="w-48 h-48 rounded-full"
        />
      </div>
      <div className="md:w-2/3 md:pl-10">
        <h2 className="text-3xl font-bold mb-5">Front-End Developer</h2>
        <p className="mb-5">
          Hi, I'm Elnur - a Junior Front-End Developer at upscore.ai who's on an
          exciting journey to master web development and conquer the world of
          React! My enthusiasm for creating captivating user experiences sparked
          my passion for coding.
        </p>
        <p className="mb-5">
          Armed with a toolkit of HTML, CSS, and JavaScript, I'm dedicated to
          crafting polished interfaces that seamlessly blend form and function.
          My commitment to user-centered design drives me to ensure every pixel
          and interaction serves a purpose in enhancing the user journey.
        </p>
        <p className="mb-5">
          Beyond my foundational skills, I've set my sights on mastering React -
          a powerful library that brings web applications to life with its
          component-based architecture. With each line of code I write, I'm
          eager to see how React's magic transforms my projects into dynamic and
          interactive experiences that users will love.
        </p>
        <p className="mb-5">
          My ultimate goal is to evolve into a skilled software engineer who can
          tackle complex challenges and contribute to the development of
          impactful applications. I understand that this journey requires
          continuous learning, dedication, and pushing beyond my comfort zone.
          Each line of code I write is a step toward realizing that goal.
        </p>
        <p className="mb-5">
          I'm grateful for the opportunity to learn from experienced mentor Yura
          and immerse myself in the world of software development.
        </p>
        <p>
          This is my{' '}
          <a
            href="https://www.linkedin.com/in/elnur-mammadov-94530579/"
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
          >
            LinkedIn
          </a>{' '}
          account. Thank you for visiting upscore.ai, and I hope our website
          helps you achieve your goals and succeed on the IELTS exam. Start
          improving your writing score today at{' '}
          <a
            href="/trainer"
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
          >
            upscore.ai/trainer
          </a>
          !
        </p>
      </div>
    </div>
  );
};

export default ElnurTeamMember;
